import { parseEurosToCents } from './manual-bpi-amount';

/**
 * Montant tel qu'il figure sur un relevé ou un chèque (BED-25) : espaces de
 * milliers et « € » ignorés, au plus 2 décimales (virgule ou point). Une
 * saisie ambiguë (« 1.200 », « 1,200 », « 1.200,50 ») est refusée plutôt que
 * lue 1,20 €. Sert au montant reçu (confirmation) et au montant remboursé.
 */
export function parseReceivedAmount(raw: string): number | null {
  const compact = raw.replace(/[\s€]/g, '');
  if (!/^\d+([.,]\d{1,2})?$/.test(compact)) return null;
  return parseEurosToCents(compact);
}
